function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

(function ($) {
	"use strict";

	$(function () {
		function resetKeyEvents($offcanvasLinks) {
			$offcanvasLinks.off('keydown');
		}

		function setKeyEvents($offcanvasLinks) {
			$offcanvasLinks.last().on('keydown', (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					$offcanvas.removeClass(activeClass);
					$body.removeClass("u-overflow-hidden");
					$trigger.first().focus();
				}
			});

			$offcanvasLinks.first().on('keydown', (e) => {
				if (e.key === 'Tab' && e.shiftKey) {
					$offcanvas.removeClass(activeClass);
					$body.removeClass("u-overflow-hidden");
					$trigger.first().focus();
				}
			});
		}

		const activeClass = "site-offcanvas--is-active";

		const $body = $("html, body");
		const $trigger = $(".js-site-offcanvas-trigger");
		const $offcanvas = $(".js-site-offcanvas");
		const $close = $(".js-site-offcanvas-close");

		let $offcanvasLinks = $('.offcanvas-menu__link:visible,.site-offcanvas__btn:visible');

		const getOffcanvasLinks = debounce(function () {
			$offcanvasLinks = $('.offcanvas-menu__link:visible,.site-offcanvas__btn:visible');
			resetKeyEvents($offcanvasLinks);
			setKeyEvents($offcanvasLinks);
		}, 250);

		window.addEventListener('resize', getOffcanvasLinks);

		$trigger.on("click", function () {
			$offcanvas.addClass(activeClass);
			$body.addClass("u-overflow-hidden");
		});

		$close.on("click", function () {
			$offcanvas.removeClass(activeClass);
			$body.removeClass("u-overflow-hidden");
		});

		$trigger.on('keydown', (e) => {
			if (e.key === 'Enter' || e.code === 'Space') {
				setTimeout(function () {
					$offcanvasLinks.first().focus();
				}, 50);
			}
		});

		setKeyEvents($offcanvasLinks);
	});
})(jQuery);
